/**
 * Map browser hostname to default API brand (X-Default-Brand).
 * Keep logic shared between the Next.js proxy and OpenAPI client headers.
 */
export function parseHostnameFromEnv(envVal: string | undefined): string {
  if (!envVal?.trim()) return ''
  const s = envVal.trim()
  try {
    const withProto = s.includes('://') ? s : `https://${s}`
    return new URL(withProto).hostname.toLowerCase()
  } catch {
    return s.split(':')[0].split('/')[0].toLowerCase()
  }
}

/**
 * Return the brand for the given hostname.
 *
 * Both the AiClaims root site (aiclaimsHostEnv) and the AiClaims portal
 * (aiclaimsPortalHostEnv) resolve to `aiclaims`; every other hostname maps to
 * `wysehub`.
 */
export function defaultBrandFromHostname(
  hostname: string,
  aiclaimsHostEnv: string | undefined,
  aiclaimsPortalHostEnv?: string | undefined,
): 'wysehub' | 'aiclaims' {
  const h = hostname.toLowerCase()
  const ac = parseHostnameFromEnv(aiclaimsHostEnv)
  if (ac && h === ac) return 'aiclaims'
  const portal = parseHostnameFromEnv(aiclaimsPortalHostEnv)
  if (portal && h === portal) return 'aiclaims'
  return 'wysehub'
}
